var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { isSmallTextFieldSizes } from '../../utils/input';
import { Typography } from '../Typography/Typography';
import { inputLabel } from './styles';
export const TextFieldLabel = (_a) => {
    var { disabled, hasError, hasValue, isFocused, label, labelOption, size } = _a, labelProps = __rest(_a, ["disabled", "hasError", "hasValue", "isFocused", "label", "labelOption", "size"]);
    const small = isSmallTextFieldSizes(size);
    const isShrunk = isFocused || hasValue || (labelOption === 'sticky' && !small);
    const isHidden = isShrunk && (labelOption === 'nonshrink' || small);
    return (_jsx(Typography, Object.assign({ variant: isShrunk ? 'footnote' : 'body', display: isHidden ? 'hidden' : undefined, component: "label", weight: isShrunk ? 'medium' : 'normal', className: inputLabel({
            size,
            shrunk: isShrunk,
            disabled,
            error: hasError,
            focused: isFocused,
        }) }, labelProps, { children: label })));
};
